import { settingsSelector } from '../../selectors/settings';

export default class ToolboxController {
    static $inject = ['$ngRedux','SettingsActions','gridHelpers'];
    constructor($ngRedux, SettingsActions,gridHelpers) {
        this.gridHelpers = gridHelpers;
        this.unsubscribe = $ngRedux.connect(mapStateToThis, { ...SettingsActions })(this);
        this.hideRisezerFor = ['main', 'activities'];
        this.allowResize = this.hideRisezerFor.indexOf(this.widget) === -1;
    }

    $onDestroy() {
        this.unsubscribe();
    }

    removeWidget() {
        const setting = this.settings[this.widget];
        if (setting.display) {
            setting.display = 'none';
        } else if (setting.visible) {
            setting.visible = false;
        } else {
            return;
        }

        this.saveChanges(this.settings, true);
    }

    changeDisplayType(displayType) {
        if (!this.allowResize) {
            return;
        }
        this.settings[this.widget].display = displayType;
        this.saveChanges(this.gridHelpers.adjustPositions(this.settings), true);
    }
}

function mapStateToThis(state) {
    return { settings: settingsSelector(state) };
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/toolbox/toolbox.controller.js